<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          Upload new Customer Specific Fees Excel file
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <div class="large-12 medium-12 small-12 cell">
              <b-field>
                <b-upload
                  v-model="dropFiles"
                  multiple
                  drag-drop
                  expanded
                  required
                >
                  <section class="section">
                    <div class="content has-text-centered">
                      <p>
                        <b-icon icon="upload" size="is-large"></b-icon>
                      </p>
                      <p>Drop your files here or click to upload</p>
                    </div>
                  </section>
                </b-upload>
              </b-field>

              <div class="tags">
                <span
                  v-for="(file, index) in dropFiles"
                  :key="index"
                  class="tag is-primary"
                >
                  {{ file.name }}
                  <button
                    class="delete is-small"
                    type="button"
                    @click="deleteDropFile(index)"
                  ></button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button
          slot="right"
          native-type="submit"
          type="is-primary"
          v-on:click="submitFile()"
        >
          Submit
        </b-button>
        <b-button slot="right" type="is-danger" @click="cancel">
          Cancel
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import CustomerSpecificPricesService from "@/services/CustomerSpecificPricesService";
// @group Customers
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: Number,
      default: -1
    }
  },
  /*
      Defines the data used by the component
    */
  data() {
    return {
      customerSpecificPricesService: new CustomerSpecificPricesService(),
      isModalActive: false,
      file: {},
      dropFiles: []
    };
  },

  methods: {
    cancel() {
      this.$emit("close");
    },
    /*
        Submits the file to the server
      */
    deleteDropFile(index) {
      this.dropFiles.splice(index, 1);
    },
    submitFile() {
      if (this.dropFiles[0]) {
        this.customerSpecificPricesService
          .upload(this.dropFiles[0], this.customerId)
          .then(resp => {
            if (resp.data.msg.length != 0) {
              this.$buefy.dialog.alert({
                title: "Customer Specific Fees Upload was unsuccessful !!!",
                message: resp.data.msg.join("\n"),
                type: "is-danger",
                hasIcon: true,
                icon: "times-circle",
                iconPack: "fa",
                ariaRole: "alertdialog",
                ariaModal: true
              });
            } else {
              this.$buefy.toast.open({
                message: "Customer Specific Fees was Successfully Uploaded!!",
                type: "is-success"
              });
              this.$emit("confirm");
            }
            this.isModalActive = false;
            this.dropFiles = [];
          })
          .catch(err => {
            this.$buefy.dialog.alert({
              title: "Customer Specific Fees Upload was unsuccessful !!!",
              message: err["response"]["data"]["detail"],
              type: "is-danger",
              hasIcon: true,
              icon: "times-circle",
              iconPack: "fa",
              ariaRole: "alertdialog",
              ariaModal: true
            });
            this.isModalActive = false;
            this.dropFiles = [];
          });
      } else {
        this.$buefy.dialog.alert({
          title: "Customer Specific Fees Upload was unsuccessful !!!",
          message: "Please Choose a File First",
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.$emit("close");
      }
    }
  }
};
</script>
